
const awsconfig =  {
    "aws_appsync_graphqlEndpoint": "https://yrdbgobucnhv3jz3ouh22qjiiy.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-57aog5lbhneddaozu22nfcpv7y",
};

export default awsconfig;